<template>
  <div>
    <div id="sidebar" :class="{ open: burgerMenuOpen }">
      <div class="logo">
        <img v-if="logoFile" @click="goHome()" :src="logoFile" />
        <img v-if="!logoFile" @click="goHome()" src="../assets/logo.svg" />
      </div>

      <!--
            <router-link to="/">
                <div style="background-image: url(./icons/dashboard.png)" class="icon"></div>
                Dashboard
            </router-link>
            -->

      <router-link to="/projects">
        <div
          style="background-image: url(./icons/projects.png)"
          class="icon"
        ></div>
        Projects
      </router-link>

      <router-link to="/tasks">
        <div
          style="background-image: url(./icons/tasks.png)"
          class="icon"
        ></div>
        Tasks
      </router-link>

      <router-link v-if="app_user.jobTitle === 'Finance'" to="/approvals">
        <div
          style="background-image: url(./icons/tasks.png)"
          class="icon"
        ><div v-if="$store.getters.approvalCount" class="badge" /></div>
        Approvals
      </router-link>

      <!--
            <router-link to="/users">
                <div style="background-image: url(./icons/users.png)" class="icon"></div>
                Users
            </router-link>
            -->

      <router-link to="/reports">
        <div
          style="background-image: url(./icons/reports.png)"
          class="icon"
        ></div>
        Reports
      </router-link>

      <router-link to="/resourcing" v-if="is_admin || is_super_admin">
        <div
          style="background-image: url(./icons/users.png)"
          class="icon"
        ></div>
        Resourcing
      </router-link>

      <router-link to="/analytics" v-if="is_super_admin">
        <div
          style="background-image: url(./icons/reports.png)"
          class="icon"
        ></div>
        Spend
      </router-link>

      <router-link to="/suppliers" v-if="is_super_admin">
        <div
          style="background-image: url(./icons/suppliers.png)"
          class="icon"
        ></div>
        Suppliers
      </router-link>

      <router-link to="/people" v-if="is_super_admin">
        <div style="background-image: url(./icons/user.png)" class="icon"></div>
        People
      </router-link>

      <router-link to="/organisations" v-if="is_super_admin">
        <div
          style="background-image: url(./icons/users.png)"
          class="icon"
        ></div>
        Organisations
      </router-link>

    </div>

    <div
      class="burger-bg"
      :class="{ in: burgerMenuOpen }"
      @click="toggleMenu()"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  methods: {
    goHome() {
      this.$router.replace('/projects');
    },
    toggleMenu() {
      this.$store.dispatch('setBurgerMenuOpen', !this.burgerMenuOpen);
    },
  },
  computed: {
    app_user() {
      return this.$store.getters.app_user;
    },
    is_admin(){
      return this.app_user && this.app_user.role === 'Admin';
    },
    is_super_admin() {
      return this.app_user && this.app_user.role === 'SuperAdmin';
    },
    logoFile() {
      if (
        !this.app_user ||
        !this.app_user.organization ||
        !this.app_user.organization.logoUrl.includes('http')
      )
        return null;
      return this.app_user.organization.logoUrl || null;
    },
    burgerMenuOpen() {
      return this.$store.getters.burgerMenuOpen;
    },
  },
};
</script>
<!--TODO - Add Scoped-->
<style lang="scss" scoped>
@import '../styles/colors.scss';

#sidebar {
  background: $sidebar-color;
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100%;
  z-index: 2000;

  @media screen and (max-width: 1430px) {
    top: 80px;
    height: calc(100% - 80px);
    left: -330px;
    transition: left 0.5s;

    &.open {
      left: 0;
    }
  }

  .logo {
    background: $dark-color;
    height: 80px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      height: 50px;
      margin-left: 40px;
    }
  }

  a {
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
    color: $sidebar-inactive;
    display: block;
    margin: 0 15px;
    border-radius: 3px;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 25px;
    transition: all 0.2s;

    &:hover {
      color: rgba(255, 255, 255, 0.5);

      .icon {
        background-position: center top 0;
        opacity: 0.5;
      }
    }

    .icon {
      margin-right: 15px;
      width: 20px;
      height: 20px;
      //overflow: hidden;
      background-repeat: no-repeat;
      background-size: 20px 40px;
      background-position: center top -20px;
      position: relative;

      .badge {
        height: 8px;
        width: 8px;
        border-radius: 4px;
        background-color: #E6B400;
        display: inline-block;

        position: absolute; /* Position the badge within the relatively positioned icon */
        top: -4px;
        right: -4px;
      }
    }

    &.router-link-exact-active {
      color: white;
      background-color: $sidebar-active;

      .icon {
        background-position: center top 0;
      }

      &:hover {
        color: white;
        .icon {
          opacity: 1;
        }
      }
    }
  }
}

.burger-bg {
  top: 200%;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1999;

  @media screen and (max-width: 1430px) {
    &.in {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 80px;
      left: 0;
      background: #26292f;
      opacity: 0.6;
    }
  }
}
</style>
